<template>
<!-- Hero.vue -->
    <div class="hero" :class="{ 'hero-small': smallHero}" :js-hero-swiper="callSwiperJs ? '' : null">

        <div :class="['hero__container', { 'swiper-container': callSwiperJs }]">
            <div :class="['hero__wrapper', { 'swiper-wrapper': callSwiperJs }]">
                <template v-for="slide in slides" :key="slide.id">
                    <a v-if="slide.link" :href="slide.link" :class="['hero-slide', { 'swiper-slide': callSwiperJs }]" :style="'background-image:url(' + slide.image + ');'">
                        <div class="hero-slide__details" :class="slide.imgTheme">
                            <h1>
                                <span class="hero-slide__subtitle">{{ slide.subtitle }}</span>
                                <span class="hero-slide__title">{{ slide.title}}</span>
                            </h1>
                            <div class="hero-slide__caption">{{ slide.caption }}</div>
                        </div>
                    </a>
                    <div v-else :class="['hero-slide', { 'swiper-slide': callSwiperJs }]" :style="'background-image:url(' + slide.image + ');'">
                        <div class="hero-slide__details" :class="slide.imgTheme">
                            <h1>
                                <span class="hero-slide__subtitle">{{ slide.subtitle }}</span>
                                <span class="hero-slide__title">{{ slide.title}}</span>
                            </h1>
                            <div class="hero-slide__caption">{{ slide.caption }}</div>
                        </div>
                    </div>
                </template>
            </div>
            <template v-if="callSwiperJs">
                <button type="button" class="hero__swiper-button-prev" js-hero-swiper-button-prev>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
                </button>
                <button type="button" class="hero__swiper-button-next" js-hero-swiper-button-next>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
                </button>
            </template>
        </div>
    </div>
<!-- /Hero.vue -->
</template>

<script>

	export default {
		name: 'Hero',
		
		props: ['slides', 'smallHero'],
		
		computed: {
			callSwiperJs() {
				return this.slides != null && this.slides.length > 1;
			}
		}
	}
	
</script>